/* Prod */
// export const API_URL = "http://51.178.55.74:8000/api/";
/* Dev */
// export const API_URL = "http://151.80.155.16:8001/api/";

export const API_URL = "https://dev-api-merge.digitalmatch.eu:8443/api/";
// export const API_URL = "https://api.digitalmatch.eu:8443/api/";

export default API_URL;
